/* eslint-disable no-loop-func */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { GetFoldersByUserIdDto } from "../../types/FolderPermission";
import { useDrop } from "react-dnd";
import FolderNode from "./FolderNode";
import useApi from "../../hooks/useApi";
import { useUser } from "../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { FolderRequestDto, FolderSearchRequestDto, MoveFolderDto } from "../../types/Folder";
import {
  getFoldersByParentFolder,
  getRecursiveFoldersBySearch,
  moveFolder,
} from "../../services/folderService";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./Folder.scss";
import { RootState } from "../../redux/store";
import { clearFolder } from "../../redux/folderSlice";
import { FolderFileType } from "../../data/Enums";
import { clearResourceModified } from "../../redux/resourceModifiedSlice";
import { clearResourceDeleted } from "../../redux/resourceDeletedSlice";
import { clearSelectedFolder, setSelectedFolder } from "../../redux/selectedFolderSlice";
import { setResourceCreated } from "../../redux/resourceCreatedSlice";
import { clearRowSelectedFolder } from "../../redux/rowSelectedSlice";
import { triggerClearSearch } from "../../redux/clearSearchTextSlice";
import { useToaster } from "../../hooks/useToaster";
import { AUDITRACEACTIONS, GLOBALSETTINGS, SEVERITIES } from "../../data/constants";
import { clearDragRowFolder } from "../../redux/dragRowSlice";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import {
  FOLDERTREEMESSAGES,
  GLOBALMESSAGES,
  MOVEFOLDER_SAMELOCATION,
  SOURCE_DONT_HAVE_PERMISSION,
  TARGETFOLDER_DONT_HAVE_PERMISSION,
  MOVEFOLDER_SUCCESSFUL,
} from "../../constants/messages";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { addBreadcrumbs, resetBreadcrumbs } from "../../redux/breadcrumbSlice";
import { getCurrentESTTime } from "../../utils/dateHelper";
import { clearSuggestedFolderSelected } from "../../redux/suggestedFolderSelectedSlice";

const FolderTree: React.FC = () => {
  const [folders, setFolders] = useState([]);
  const [expanded, setExpanded] = useState<number[]>([]);
  const [loadingRoot, setLoadingRoot] = useState<boolean>(false);
  const [loading, setLoading] = useState<number | null>(null);
  const [selectedFolderId, setSelectedFolderId] = useState<number | null>(-1);
  const { executeApi } = useApi();
  const { userId } = useUser();
  const dispatch = useDispatch();
  const showToaster = useToaster();
  const hasRun = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const parentFolderFromURL = parseInt(searchParams.get("parentFolderId"), 10);
  const selectedFolderFromURL = parseInt(searchParams.get("selectedFolderId"), 10);
  const newlyAddedSubFolder = useSelector((state: RootState) => state.folders);
  const deletedFolder = useSelector((state: RootState) => state.resourceDeleted);
  const modifiedSubFolder = useSelector((state: RootState) => state.resourceModified);
  const rowSelected = useSelector((state: RootState) => state.rowSelected);
  const dragRowSelected = useSelector((state: RootState) => state.dragRowSelected);
  const suggestedFolderSelected = useSelector((state: RootState) => state.suggestedFolderSelected);

  const getFolderById = (folderId: number) => {
    return folders.find((folder) => folder.folderId === folderId);
  };

  useEffect(() => {
    if (selectedFolderId === -1) {
      dispatch(
        setSelectedFolder({
          folderId: null,
          folderName: FOLDERTREEMESSAGES.ROOT_FOLDER,
          canEdit: true,
        }),
      );
    } else {
      const folder = getFolderById(selectedFolderId);
      if (folder) {
        dispatch(
          setSelectedFolder({
            folderId: selectedFolderId,
            folderName: folder.folderName,
            canEdit: folder.canEdit,
          }),
        );
        prepareBreadCrumbs(folder.folderId);
      }
    }
  }, [selectedFolderId]);

  const loadFolders = async (parentFolderId: number, passedFolderId: number, fileId: number) => {
    const folderid = fileId > -1 ? parentFolderId : passedFolderId;
    if (folderid) {
      refreshGlobalFolders(folderid);
    }
    scrollToFilesSection();
  };

  useEffect(() => {
    const loadSuggestFolder = async () => {
      if (
        suggestedFolderSelected !== null &&
        suggestedFolderSelected.folderId !== GLOBALSETTINGS.DEFAULT_STATE
      ) {
        await loadFolders(
          suggestedFolderSelected.parentFolderId,
          suggestedFolderSelected.folderId,
          -1,
        );
        dispatch(clearSuggestedFolderSelected());
      }
    };
    loadSuggestFolder();
  }, [suggestedFolderSelected]);

  useEffect(() => {
    const loadFromUrl = async () => {
      if (parentFolderFromURL > -1) {
        if (parentFolderFromURL) {
          refreshGlobalFolders(parentFolderFromURL, false);
        }
      } else {
        await handleRowSelectFolder(
          parentFolderFromURL === -1 ? null : parentFolderFromURL,
          true,
          false,
        );
      }
      scrollToFilesSection();
    };
    if (
      window.location.pathname !== GLOBALSETTINGS.DEFAULT_PAGE &&
      window.location.pathname !== GLOBALSETTINGS.LIST_DETAIL_PAGE
    ) {
      return;
    }
    // parentFolderId -1 is the root. A missing parent is stored as 0 on
    // notification links; notificationDestination rewrites that to -1 before
    // navigating, otherwise this effect skips the folder and nothing highlights.
    if (parentFolderFromURL >= -1) {
      loadFromUrl();
    }
  }, [parentFolderFromURL]);

  useEffect(() => {
    const loadBreadCrum = async () => {
      await handleRowSelectFolder(selectedFolderFromURL === -1 ? null : selectedFolderFromURL);
      navigate(location.pathname, { replace: true });
    };
    if (!isNaN(selectedFolderFromURL)) {
      loadBreadCrum();
    }
  }, [selectedFolderFromURL]);

  const scrollToFilesSection = () => {
    const targetElement = document.getElementById("all-files");
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop + 120,
        behavior: "smooth",
      });
    }
  };

  const prepareBreadCrumbs = (folderId: number) => {
    let parentFolders: GetFoldersByUserIdDto[] = [];
    let currentFolder = folders.find((f) => f.folderId === folderId);

    if (currentFolder) {
      parentFolders.push(currentFolder);
    }

    while (currentFolder) {
      const parentId = currentFolder?.parentFolderId;
      const parentFolder = folders.find((f) => f.folderId === parentId);
      if (!parentFolder) break;

      parentFolders.unshift(parentFolder);
      currentFolder = parentFolder;
    }

    const breadcrumbItems = [
      {
        id: -1,
        name: FOLDERTREEMESSAGES.ROOT_FOLDER,
        path: `${GLOBALSETTINGS.DEFAULT_PAGE}?selectedFolderId=-1`,
      },
      ...parentFolders.map((f) => ({
        id: f.folderId,
        name: f.folderName,
        path: `${GLOBALSETTINGS.LIST_DETAIL_PAGE}?selectedFolderId=${f.folderId}`,
      })),
    ];

    dispatch(resetBreadcrumbs());
    dispatch(addBreadcrumbs(breadcrumbItems));
  };

  useEffect(() => {
    if (
      location.pathname !== GLOBALSETTINGS.DEFAULT_PAGE &&
      location.pathname !== "/" &&
      location.pathname !== `${GLOBALSETTINGS.LIST_DETAIL_PAGE}`
    ) {
      setExpanded([]);
      setFolders([]);
      setSelectedFolderId(null);
      dispatch(
        setSelectedFolder({
          folderId: -1,
          folderName: FOLDERTREEMESSAGES.ROOT_FOLDER,
          canEdit: false,
        }),
      );
    }
  }, [location.pathname]);

  useEffect(() => {
    if (rowSelected.parentFolderId > -1) {
      handleRowSelectFolder(rowSelected.parentFolderId, true, true);
      dispatch(clearRowSelectedFolder());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelected]);

  useEffect(() => {
    const { folder, fromGrid } = newlyAddedSubFolder;

    const addNewFolder = async () => {
      if (folder && folder.folderId > 0) {
        const isRootFolderExpanded = expanded.includes(null);
        if (!isRootFolderExpanded) {
          await fetchFolders(null);
        }
        if (!expanded.includes(folder.parentFolderId)) {
          setExpanded((prev) => [...prev, folder.parentFolderId]);
        }

        setFolders((prevFolders) => {
          const folderIds = new Set(prevFolders.map((folder) => folder.folderId));
          if (!folderIds.has(folder.folderId)) {
            return [folder, ...prevFolders];
          }
          return prevFolders;
        });

        setFolders((prevFolders) =>
          prevFolders.map((f) =>
            f.folderId === folder.parentFolderId
              ? { ...f, childFolderCount: (f.childFolderCount || 0) + 1 }
              : f,
          ),
        );

        if (fromGrid) {
          dispatch(
            setSelectedFolder({
              folderId: folder.parentFolderId,
              folderName: folder.folderName,
              canEdit: folder.canEdit,
            }),
          );
          setSelectedFolderId(folder.parentFolderId);
        }
        dispatch(clearFolder());
      }
    };
    if (newlyAddedSubFolder?.folder) {
      addNewFolder();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [newlyAddedSubFolder, dispatch]);

  useEffect(() => {
    const { modifiedRow, type } = modifiedSubFolder;
    if (
      modifiedRow &&
      type === FolderFileType[FolderFileType.Folder] &&
      modifiedRow.folderId &&
      modifiedRow.folderId > -1
    ) {
      setFolders((prevFolders) =>
        prevFolders.map((folder) =>
          folder.folderId === modifiedRow.folderId
            ? { ...folder, folderName: modifiedRow.description ?? "" }
            : folder,
        ),
      );
      dispatch(clearResourceModified());
    }
  }, [modifiedSubFolder, dispatch]);

  useEffect(() => {
    if (deletedFolder && deletedFolder.folderId > -1) {
      setFolders((prevFolders) =>
        prevFolders.filter((folder) => folder.folderId !== deletedFolder.folderId),
      );

      dispatch(clearResourceDeleted());
    }
  }, [deletedFolder, dispatch]);

  const refreshGlobalFolders = async (parentId: number | null, replaceSearch = true) => {
    if (parentId === null) {
      setLoadingRoot(true);
    } else {
      setLoading(parentId);
    }

    const folderRequest: FolderSearchRequestDto = {
      parentFolderId: parentId,
      isDeleted: false,
    };

    const newFolders = await executeApi<FolderSearchRequestDto, GetFoldersByUserIdDto[]>(
      getRecursiveFoldersBySearch,
      folderRequest,
    );

    if (newFolders && newFolders.length > 0) {
      // Ensure root ("All Files/Folders") is expanded if not already
      if (!expanded.includes(null)) {
        setExpanded((prev) => [...prev, null]);
        await refreshFolders(null);
      }

      if (newFolders !== null) {
        setFolders((prevFolders) => {
          const folderIds = new Set(prevFolders.map((folder) => folder.folderId));
          const uniqueNewFolders = newFolders.filter((folder) => !folderIds.has(folder.folderId));
          return [...prevFolders, ...uniqueNewFolders];
        });

        // Expand newly loaded folders but keep previous expanded ones (including root)
        setExpanded((prev) => [...new Set([...prev, ...newFolders.map((f) => f.folderId)])]);
      }
    }

    handleDispatch(parentId);
    navigateToPage(parentId, replaceSearch);
    setLoading(null);
    if (parentId === null) {
      setLoadingRoot(false);
    }
  };

  const refreshFolders = async (parentId: number) => {
    if (parentId === null) {
      setLoadingRoot(true);
    } else {
      setLoading(parentId);
    }
    const folderRequest: FolderRequestDto = {
      userId: userId,
      parentFolderId: parentId,
      isDeleted: false,
    };

    const newFolders = await executeApi<FolderRequestDto, GetFoldersByUserIdDto[]>(
      getFoldersByParentFolder,
      folderRequest,
    );

    if (newFolders !== null) {
      setFolders((prevFolders) => {
        const folderIds = new Set(prevFolders.map((folder) => folder.folderId));
        const uniqueNewFolders = newFolders.filter((folder) => !folderIds.has(folder.folderId));
        return [...prevFolders, ...uniqueNewFolders];
      });
    }

    setExpanded((prev) => {
      let updatedExpanded = [...prev, parentId];
      let currentParentId = folders.find((f) => f.folderId === parentId)?.parentFolderId;

      // // Add parent folders to the expanded list if they're not already expanded
      while (currentParentId !== null && currentParentId !== undefined) {
        if (!updatedExpanded.includes(currentParentId)) {
          updatedExpanded.push(currentParentId);
        }

        // eslint-disable-next-line no-loop-func
        const parentFolder = folders.find((f) => f.folderId === currentParentId);
        currentParentId = parentFolder ? parentFolder.parentFolderId : null;
      }

      return updatedExpanded;
    });
    setLoading(null);
    if (parentId === null) {
      setLoadingRoot(false);
    } else {
      setLoading(null);
    }
  };

  useEffect(() => {
    if (dragRowSelected.draggedFolderId > 0 && dragRowSelected.parentFolderId > 0) {
      handleMoveFolder(dragRowSelected.draggedFolderId, dragRowSelected.parentFolderId);
      dispatch(clearDragRowFolder());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dragRowSelected]);

  // Load child folders dynamically when expanded
  const fetchFolders = async (parentId: number) => {
    if (expanded.includes(parentId)) {
      setExpanded((prev) => prev.filter((id) => id !== parentId));
    } else {
      await refreshFolders(parentId);
    }
  };

  // Handle moving a folder
  const handleMoveFolder = async (draggedId: number, targetId: number | null) => {
    if (draggedId === targetId || isDescendant(draggedId, targetId)) return;
    const draggedFolder = getFolderById(draggedId);
    const targetFolder = getFolderById(targetId);
    if (draggedFolder && draggedFolder.canEdit === false) {
      showToaster(SOURCE_DONT_HAVE_PERMISSION(draggedFolder?.folderName), SEVERITIES.WARNING);
      return;
    }
    if (draggedFolder && targetId === null && draggedFolder.parentFolderId === null) {
      //dont allow 'All Files/Folders' -> 'All Files/Folders'
      showToaster(MOVEFOLDER_SAMELOCATION(draggedFolder?.folderName), SEVERITIES.WARNING);
      return;
    }
    if (draggedFolder && targetFolder && targetFolder.canEdit === false) {
      showToaster(TARGETFOLDER_DONT_HAVE_PERMISSION(targetFolder?.folderName), SEVERITIES.WARNING);
      return;
    }
    if (draggedFolder && targetId === draggedFolder.parentFolderId) {
      //dont allow if user is dropping on the same parent folder.
      showToaster(MOVEFOLDER_SAMELOCATION(draggedFolder?.folderName), SEVERITIES.WARNING);
      return;
    }
    setFolders((prevFolders) =>
      prevFolders.map((folder) =>
        folder.folderId === draggedId ? { ...folder, parentFolderId: targetId } : folder,
      ),
    );
    if (targetId !== null) {
      setExpanded((prev) => Array.from(new Set([...prev, targetId])));
    }

    const moveFolderDto: MoveFolderDto = {
      folderFileType: FolderFileType.Folder,
      typeId: draggedId,
      parentFolderId: targetId,
      userId: userId,
    };

    var result = await executeApi<MoveFolderDto, boolean>(moveFolder, moveFolderDto);

    let actionDescription = AUDITRACEACTIONS.MOVEDFOLDER.toString();
    let objectName = "";

    if (result) {
      await handleRowSelectFolder(targetId);
      const targetFolder = getFolderById(targetId);
      const oldFolderName = draggedFolder?.folderName;
      const newFolderName =
        targetId === null ? FOLDERTREEMESSAGES.ROOT_FOLDER : targetFolder?.folderName;
      showToaster(MOVEFOLDER_SUCCESSFUL(oldFolderName, newFolderName), SEVERITIES.SUCCESS);
      objectName = "Moved " + oldFolderName + " To " + newFolderName;
    } else {
      actionDescription += GLOBALMESSAGES.FAILED_ADDITION;
    }

    logAuditTrace(
      {
        userId: userId,
        objectType: FolderFileType[FolderFileType.Folder],
        objectId: draggedId,
        objectName: objectName,
        action: actionDescription,
        navigationDateTime: getCurrentESTTime(),
      },
      dispatch,
    );
  };

  // Check if dragged folder is a descendant of the target folder
  const isDescendant = (draggedId: number, targetId: number): boolean => {
    let parent = folders.find((folder) => folder.folderId === targetId)?.parentFolderId;
    while (parent) {
      if (parent === draggedId) return true;
      const foundFolder = folders.find((folder) => folder.folderId === parent);
      parent = foundFolder ? foundFolder.parentFolderId : null;
    }
    return false;
  };

  // Render folder tree dynamically
  const renderTree = (parentId: number | null) => {
    return folders
      .filter((folder) => folder.parentFolderId === parentId)
      .map((folder) => (
        <FolderNode
          key={folder.folderId}
          folder={folder}
          folders={folders}
          onExpand={() => handleFolderClick(folder.folderId)}
          expanded={expanded.includes(folder.folderId)}
          onMoveFolder={handleMoveFolder}
          loading={loading === folder.folderId}
          selectedFolderId={selectedFolderId}
        >
          {expanded.includes(folder.folderId) && <ul>{renderTree(folder.folderId)}</ul>}
        </FolderNode>
      ));
  };

  // Using useDrop for "All Files/Folders" section
  const [{ isOver }, drop] = useDrop({
    accept: FOLDERTREEMESSAGES.DRAG_TYPE,
    drop: (item: { folderId: number }, monitor) => {
      if (monitor.didDrop()) return; // Prevents multiple drop events
      handleMoveFolder(item.folderId, null); // Move folder to root
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
  });

  const handleAllFilesFolderClick = () => {
    dispatch(triggerClearSearch());
    fetchFolders(null);
    dispatch(clearSelectedFolder());
    dispatch(setResourceCreated({ parentFolderId: null }));
    dispatch(
      setSelectedFolder({
        folderId: null,
        folderName: FOLDERTREEMESSAGES.ROOT_FOLDER,
        canEdit: true,
      }),
    );
    setSelectedFolderId(-1);
    navigateToPage(null, true);
    scrollToFilesSection();
  };

  const handleFolderClick = async (parentId: number) => {
    dispatch(triggerClearSearch());
    await fetchFolders(parentId);
    handleDispatch(parentId);
    navigateToPage(parentId, true);
  };

  const handleDispatch = (parentId: number) => {
    setSelectedFolderId(parentId ?? -1);
    dispatch(setResourceCreated({ parentFolderId: parentId }));
  };

  const handleRowSelectFolder = async (
    parentId: number,
    triggerDispatch = true,
    replaceSearch = true,
  ) => {
    dispatch(triggerClearSearch());
    //if root folder is not expanded, expand it.
    const isRootFolderExpanded = expanded.includes(null);
    if (!isRootFolderExpanded) {
      await fetchFolders(null);
    }
    await refreshFolders(parentId);
    if (triggerDispatch) {
      handleDispatch(parentId);
      navigateToPage(parentId, replaceSearch);
    }
  };

  const navigateToPage = (folderId: number | null, replaceSearch = true) => {
    const destination =
      folderId === GLOBALSETTINGS.DEFAULT_STATE || folderId === null
        ? GLOBALSETTINGS.DEFAULT_PAGE
        : GLOBALSETTINGS.LIST_DETAIL_PAGE;

    if (replaceSearch) {
      navigate(destination);
    } else {
      navigate(destination + location.search);
    }
  };

  useEffect(() => {
    if (hasRun.current) return;
    dispatch(setResourceCreated({ parentFolderId: null }));
    dispatch(
      setSelectedFolder({
        folderId: null,
        folderName: FOLDERTREEMESSAGES.ROOT_FOLDER,
        canEdit: true,
      }),
    );
    hasRun.current = true;
  }, [dispatch]);
  const dropClass = isOver ? "folder-drop-target" : "folder-normal";
  return (
    <div
      className={`folder-explorer custom-scrollbar-container ${dropClass}`}
      ref={drop}
      onDragOver={(e) => e.preventDefault()}
    >
      {/* Toggle for All Files/Folders */}
      <div
        onClick={handleAllFilesFolderClick}
        className={`all-files-header ${selectedFolderId === -1 ? "selected" : ""}`}
      >
        {expanded.includes(null) ? (
          <KeyboardArrowDownIcon className="folder-icon folder-arrow" />
        ) : (
          <KeyboardArrowRightIcon className="folder-icon folder-arrow" />
        )}
        <img src="/home-storage.svg" alt="all-files-icon" className="folder-icon" />
        <span>{FOLDERTREEMESSAGES.ROOT_FOLDER}</span>
        {loadingRoot && <CircularProgress size={24} className="main-folder-loading d-none" />}
      </div>

      {/* Render child folders under "All Files/Folders" */}
      {expanded.includes(null) && <ul>{renderTree(null)}</ul>}
    </div>
  );
};

export default FolderTree;
